import {
  Box,
  Container,
  Stack,
  Typography,
  List,
  ListItem,
  ListItemText,
  alpha,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import Screen from '../../assets/images/screen-movies-series.webp';
import VideoMoviesSeries from '../../assets/videos/video-movies-series.mp4';
import { CheckRounded, ArrowForward } from '@mui/icons-material';
import {
  StyledButton,
  getTransitionStyle,
} from '../../components/Utils/UIUtils';
import { theme } from '../../theme';

export default function Section3() {
  const { t } = useTranslation();

  const features =
    t('HOME_PAGE.SECTION3.FEATURES', { returnObjects: true }) || [];

  const arrowTransitionStyle = getTransitionStyle(theme, ['transform']);
  return (
    <Container
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column-reverse', md: 'row-reverse' },
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: { xs: 3, md: '48px' },
        py: { xs: 8, md: 10 },
      }}
      maxWidth="lg"
    >
      <Stack
        gap={2}
        sx={{
          pl: { xs: 0, md: 4 },
          flexBasis: { xs: '100%', md: '50%' },
          width: '100%',
        }}
      >
        <Stack component={'header'} gap={2}>
          <Typography variant="h2" sx={{ fontSize: '32px', fontWeight: '600' }}>
            {t('HOME_PAGE.SECTION3.TITLE')}
          </Typography>
        </Stack>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontSize: '16px',
            fontWeight: '300',
          }}
        >
          <Trans
            i18nKey="HOME_PAGE.SECTION3.PARAGRAPH"
            components={{ Strong: <strong style={{ fontWeight: '600' }} /> }}
          />
        </Typography>
        <List
          disablePadding
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexDirection: 'column',
          }}
        >
          {features.map((feature, index) => (
            <ListItem
              key={index}
              disablePadding
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 1,
              }}
            >
              <CheckRounded
                sx={{
                  fontSize: '20px',
                  color: 'primary.main',
                  backgroundColor: 'primary.primarylight1',
                  borderRadius: '50%',
                  p: 0.4,
                  mt: 0.25,
                }}
              />
              <ListItemText
                primary={feature}
                sx={{
                  '& span': {
                    color: 'text.secondary',
                    fontSize: '16px',
                    fontWeight: '300',
                  },
                  m: 0,
                }}
              />
            </ListItem>
          ))}
        </List>
        <StyledButton
          variant="contained"
          size="large"
          href="/free-trial"
          sx={{
            alignSelf: 'flex-start',
            bgcolor: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.main,
            p: '12px 24px',
            fontWeight: '400',
            fontSize: '16px',
            mt: 0.5,
            '&:hover .MuiButton-endIcon ': {
              transform: 'translateX(4px)',
              ...arrowTransitionStyle,
            },
            '& .MuiButton-endIcon': {
              ...arrowTransitionStyle,
            },
            '&:hover': {
              bgcolor: theme.palette.primary.main,
              color: theme.palette.common.white,
            },
          }}
          endIcon={<ArrowForward />}
        >
          {t('HOME_PAGE.SECTION3.BUTTON')}
        </StyledButton>
      </Stack>
      <Box
        sx={{
          pr: { xs: 0, md: 4 },
          display: 'flex',
          justifyContent: { xs: 'center', md: 'flex-start' },
          flexBasis: { xs: '100%', md: '50%' },
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <img
          src={Screen}
          alt="Screen"
          style={{
            width: '100%',
            zIndex: 1,
          }}
          loading="lazy"
        />
        <Box
          sx={{
            position: 'absolute',
            top: '66%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            maxWidth: { xs: '86%', md: '76%' },
            zIndex: -1,
            overflow: 'hidden',
          }}
        >
          {' '}
          <video
            src={VideoMoviesSeries}
            autoPlay
            loop
            muted
            playsInline
            width={'100%'}
          />
        </Box>
      </Box>
    </Container>
  );
}
